/**
 * Constructs the actual admin path from the catch-all route parameters
 * For catch-all routes like [[...path]], we need to reconstruct the path
 */
export function constructAdminPath(
  pathname: string,
  params: Record<string, string | string[]>
): string {
  // Check for the catch-all route pattern
  if (pathname.includes("::...adminPath")) {
    const nonprofitSlug =
      params.nonprofitSlug || params.nonprofitSlugOrUsername;
    const pathSegments = params.adminPath;

    if (!nonprofitSlug) {
      return pathname;
    }

    let constructedPath = `/:nonprofitSlug/admin`;

    if (pathSegments) {
      if (Array.isArray(pathSegments) && pathSegments.length > 0) {
        constructedPath += `/${pathSegments.join("/")}`;
      } else if (typeof pathSegments === "string" && pathSegments.length > 0) {
        constructedPath += `/${pathSegments}`;
      }
    }

    return constructedPath;
  }

  return pathname;
}
